import { Link } from "@remix-run/react";
import { SearchInput } from "./search-input";

export function Header() {
  return (
    <header className="border-b py-4">
      <div className="container flex items-center justify-between">
        <Link to="/" className="flex items-center text-xl font-bold mr-4">
          <img 
            src="/images/logo.webp" 
            alt="Weather Route Logo" 
            className="h-8 mr-2"
          />
          <span>
            Weather <span className="text-blue-600">Route</span> Support
          </span>
        </Link>
        
        <div className="flex-1 max-w-md mx-4 hidden md:block">
          <SearchInput />
        </div>
        
        <nav className="space-x-4 md:space-x-6">
          <Link to="/" className="hover:text-blue-600 transition-colors">
            Home
          </Link>
          <Link to="/kb" className="hover:text-blue-600 transition-colors">
            Knowledge Base
          </Link>
          <Link to="/videos" className="hover:text-blue-600 transition-colors">
            Videos
          </Link>
          <Link to="/search" className="md:hidden hover:text-blue-600 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
          </Link>
        </nav>
      </div>
    </header>
  );
} 